import { Flex, FlexItem, FlexSpacer, Label, Separator, Size } from '@drawbotics/react-drylus';

import { translate as t } from '../utils';

export const OptionSeparator = () => {
  return (
    <Flex>
      <FlexItem flex>
        <Separator />
      </FlexItem>
      <FlexSpacer size={Size.SMALL} />
      <FlexItem>
        <Label>{t('or')}</Label>
      </FlexItem>
      <FlexSpacer size={Size.SMALL} />
      <FlexItem flex>
        <Separator />
      </FlexItem>
    </Flex>
  );
};
